import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

export default class InputFormEconomic extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            language: 'rus',
            id: '',
            fid: '',
            description: '',
            information: '',
            value: '',
            colorError: '#fff'
        }

        this.handleChange = this.handleChange.bind(this);
        this.erasingError = this.erasingError.bind(this);
        // this.handleBlur = this.handleBlur.bind(this)
    }


    // async handleBlur(e){
    //     await this.setState({
    //         id: e.target.dataset.id,
    //         fid: e.target.dataset.fid,
    //         description: e.target.dataset.description,
    //         information: e.target.dataset.information
    //     })
    //     this.props.onChangeValue(this.state);
    // }


    async handleChange(e) {
        e.preventDefault();
        if (this.props.verify &&
            this.props.verify === 'number') {
            this.verificationNumber(e)
        } else {
            this.setState({ value: e.target.value })
        }

        await this.setState({
            id: e.target.dataset.id,
            fid: e.target.dataset.fid,
            description: e.target.dataset.description,
            information: e.target.dataset.information
        })
        this.props.onChangeValue(this.state);
    }

    verificationNumber(e) {
        // todo заменяем запятую на точку .replace(/,/, '.')
        if (isFinite(e.target.value.replace(/,/, '.'))) {
            this.setState({ value: e.target.value.replace(/,/, '.'), colorError: '#fff' })
        } else {

            // console.log('error');
            this.setState({ colorError: '#dc3545' })
            this.erasingError();
        }
    }

    erasingError() {
        setTimeout(() => { this.setState({ colorError: '#fff' }) }, 500)
    }

    componentDidMount() {
        this.setState({ value: this.props.value })
    }

    render() {

        const width = this.props.width;
        const label = this.props.label;
        const id = this.props.id;
        const description = this.props.description;
        const placeholder = this.props.placeholder;
        const value = this.state.value;
        const className = this.props.className;

        return (
            <React.Fragment key={id}>
                <Row sm={width} className={className ? className : ''}>
                    <Col>
                        <Form.Label >{label}</Form.Label>
                    </Col>
                    <Col>
                        <p className='upper_label_position'>{this.props.upperLabel}</p>
                        <Form.Control
                            style={{
                                backgroundColor: `${this.state.colorError}`
                            }}
                            type="text"
                            data-id={id}
                            data-fid={`${this.props.nameForm}_${this.props.id}`}
                            placeholder={placeholder}
                            data-information={placeholder}
                            data-description={description}
                            value={value}
                            onChange={this.handleChange}
                            // onKeyUp={this.handleChange}
                            readOnly={this.props.readOnly ? true : false}
                            onKeyUp={this.props.veryfyProcent}
                        />
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}